<template>
  <div class="status_change_detail" :style="screenHeight">
    <div class="fixed_search" style="height: 100px">
      <div class="fixed_search_input">
        <Input v-model="agentName" placeholder="请输入员工姓名" title="员工姓名"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentNum" placeholder="请输入员工工号" title="员工工号"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentGroupName" placeholder="请输入部门名称" title="部门名称"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="statusBefore" placeholder="请选择变化前状态" clearable title="变化前状态">
          <Option v-for="(option, index) in statusList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="statusAfter" placeholder="请选择变化后状态" clearable title="变化后状态">
          <Option v-for="(option, index) in statusList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="offlineCause" placeholder="请选择离线原因" clearable title="离线原因">
          <Option v-for="(option, index) in offlineCauseList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentIp" placeholder="请输入操作IP" title="操作IP"/>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange"  :clearable="false" start-placeholder="开始时间" end-placeholder="结束时间"
                        align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" @click="exportExcel('8_2-2-1','统计报表=>状态变化明细=>导出')" v-if="roleList['8_2-2-1']">导出</Button>
      </div>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection" @sort-change="sortChange" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" sortable="custom" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <publicPop @closePublicPop="closePublicPop" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    import publicPop from '@/components/customerMange/PublicPop.vue'
    export default {
      name: "StatusChangeDetail",
      mixins:[publicFunClass,customerPublicBtn],
      components:{
        publicPop
      },
      props:{
        pageCode:String
      },
      data(){
        return {
          showPageCount:0,
          roleList:JSON.parse(localStorage.getItem("roleList")),
          screenHeight:{height:''},
          tableHeight:600,
          total:0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          pageSize:20,
          speedChangePage: 1,
          spinShow:false,
          editable:false,
          showPublicPop:false,
          popSign:'状态明细导出',
          fieldList: [
            {type: 'selection', width: 50},{key:'agentName','title':'员工姓名'},{key:'agentNum','title':'员工工号'},{key:'pstnNumber','title':'热线号码'},
            {key:'agentDeptName','title':'部门名称'},{width: 200,key:'changeTimeString','title':'时间'},{width: 150,key:'statusBeforeName','title':'变化前状态'},
            {width: 200,key:'statusAfterName','title':'变化后状态'},{key:'offlineCause','title':'离线原因'},{key:'agentIp','title':'操作IP'}
          ],
          contentList: [],
          checkIds:[],
          pstnNumber:'',
          agentGroupName:'',
          agentName:'',
          agentNum:'',
          statusBefore:'',
          statusAfter:'',
          offlineCause:'',
          offlineCauseList:[{'id': '1', 'name': '正常签出'},{'id': '2', 'name': '连接中断'},{'id': '3', 'name': '被挤下线'},{'id': '4', 'name': '分机下线'},{'id': '5', 'name': '删除座席'},{'id': '6', 'name': '强制下线'},{'id': '7', 'name': '心跳超时'}],
          starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
          statusList:[{'id': '-1', 'name': '离线'},{'id': '0', 'name': '空闲'},{'id': '1', 'name': '振铃'},{'id': '2', 'name': '通话'},{'id': '3', 'name': '保持'},{'id': '4', 'name': '后处理'},{'id': '5', 'name': '被占用'},{'id': '6', 'name': '忙碌'},{'id': '7', 'name': '离开'},{'id': '8', 'name': '仅呼出'}],
          journalType:"null",
          menuId:"null",
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          orderField:'',
          orderRule:'',
          agentIp:'',
          queryParam: null,
        }
      },
      methods:{
        //导出
        exportExcel:function (menuId,journalType) {
          this.journalType=journalType;
          this.menuId=menuId;
          this.showPublicPop=true;
        },
        closePublicPop:function (flag,operateStyle,popSign) {
          this.showPublicPop=false;
          let param={
            ids:this.checkIds.toString(),
            journalType:this.journalType+"按选中结果"+popSign,
            menuId:this.menuId,
            type:operateStyle
          };
          if(flag){
            if (operateStyle=='0'){//选中结果
              if (this.checkIds.length==0){
                this.$Modal.info({
                  title:'提示',
                  content:"请选择要导出的数据"
                });
                return false;
              }
            }
            if (operateStyle=='1'){//按搜索结果
              if(this.contentList.length==0){
                this.$Modal.info({
                  title:'提示',
                  content:"当前没有可导出的数据"
                });
                return false;
              }
              if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再导出"
                  });
                  return false;
                }
                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', operateStyle);
                this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果"+popSign);
                this.$set(this.queryParam, 'menuId', this.menuId);
                param = this.queryParam;
            }
            this.$Loading.start();
            this.operateExcelExport(param,"statusChangesDetail/exportStatusChangesDetail.json");
          }
        },
        getCustomName:function (name) {
          if(name=="agentName"){
            return "agentname";
          }
          if(name=="agentNum"){
            return "agentnum";
          }
          if(name=="pstnNumber"){
            return "pstn_number";
          }
          if(name=="agentDeptName"){
            return "agent_group_name";
          }
          if(name=="changeTimeString"){
            return "change_time_string";
          }
          if(name=="statusBeforeName"){
            return "status_before_name";
          }
          if(name=="statusAfterName"){
            return "status_after_name";
          }
          if(name=="offlineCause"){
            return "offline_cause";
          }
          if(name=="agentIp"){
            return "agent_ip";
          }
          return name;
        },
        sortChange:function(event){
          if(event && event.order){
            this.orderField=this.getCustomName(event.prop);
            this.orderRule=event.order=="descending"?"desc":"asc";
          }else{
          this.orderField="";
          this.orderRule="";
        }
          this.initSearch();
        },
        initSearch:function () {
          this.spinShow=true;
          this.$emit("closeVn",true);
          let that=this;
          let param={
            orderField:this.orderField,
            orderRule:this.orderRule,
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null",
            pstnNumber:this.pstnNumber,
            agentName:this.agentName,
            agentNum:this.agentNum,
            statusBefore:this.statusBefore,
            statusAfter:this.statusAfter,
            offlineCause:this.offlineCause,
            starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
            agentGroupName:this.agentGroupName,
            agentIp:this.agentIp
          };
          this.queryParam = param;
          
          this.$http.post("statusChangesDetail/toIndex.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.checkIds=[];
            that.contentList=res.data.obj.list.content;
            that.total=res.data.obj.list.totalSize;
          })
        },
        reset:function(){
          this.pstnNumber="";
          this.agentGroupName="";
          this.agentName="";
          this.agentNum="";
          this.statusBefore="";
          this.statusAfter="";
          this.offlineCause="";
          this.agentIp="";
          this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        }
      },
      created(){
        this.screenHeight.height=this.mountHeight(91);
        let clientHeight=document.documentElement.clientHeight;
        this.tableHeight=clientHeight-232;
      },
      destroyed(){
        this.$emit("closeVn",true);
      },
      watch:{
        pageCode:function () {
          if (this.pageCode == '8_2-2' && this.showPageCount == 0) {
            this.$emit("openVn", true);
            this.showPageCount++;
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/StatusChangeDetail.vue